import React from 'react';

import DropdownMenu from '@atlaskit/dropdown-menu';
import type { BoardToolSection } from '../../../types';
import { BoardToolSubItem } from './board-tool-sub-item';

export { BoardToolWebItemView } from './board-tool-sub-item';

interface Props {
	section: BoardToolSection;
}

export function BoardToolSectionView({ section }: Props) {
	return (
		<DropdownMenu
			placement="bottom-end"
			trigger={section.label}
			testId="software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.dropdown-menu"
		>
			{section.subItems?.map((subItem) => <BoardToolSubItem key={subItem.id} subItem={subItem} />)}
		</DropdownMenu>
	);
}
